export const apiDomain = process.env.VUE_APP_API_DOMAIN
export const getLookUpValuesByCodeUrl = apiDomain + 'lookup/getLookUpByCode/'
export const getCampaignDataUrl = apiDomain + 'search/getCampaignData/'
export const getCampaignDataWithFilterUrl = apiDomain + 'search/getCampaignDataWithFilter/'
export const getSegmentsUrl = apiDomain + 'segment/getSegments/'
export const getDashboardUrl = apiDomain + 'dashboard/getAllDashboards/'
export const createDashboardUrl = apiDomain + 'dashboard/saveDashboard/'
export const getSegmentsByDashboardIdUrl = apiDomain + 'segment/getSegmentByDashboardId/'
export const saveSegmentUrl = apiDomain + 'segment/saveSegment/'
export const editDashboardUrl = apiDomain + 'dashboard/getDashboardById/'
export const createDashboardSegments = apiDomain + 'dashboard/createDashboardSegments/'
export const deleteSegmentUrl = apiDomain + 'segment/deleteSegment/'
export const deleteDashboardUrl = apiDomain + 'dashboard/deleteDashboard/'
export const getSegmentDataUrl = apiDomain + 'search/getSegmentData/'
export const getCampaignReportUrl = apiDomain + 'search/getCampaignReport/'
export const getCampaignGiftDetailsUrl = apiDomain + 'details/getGiftDetails'
export const getCampaignMemberFilterUrl = apiDomain + 'donor/getDonorDataWithFilter'
export const getCampaignUrl = apiDomain + 'donor/getCampaignDetails'
export const getCampaignDetailsUrl = apiDomain + 'donor/getCampaignDetails'
